import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, XIcon } from "lucide-react";
import { buyers } from "../data/content";
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 14000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const show = () => {
      setIndex(Math.floor(Math.random() * buyers.length));
      setMinutesAgo(Math.floor(Math.random() * 9) + 1);
      setOpen(true);
      hideTimer = window.setTimeout(() => setOpen(false), VISIBLE_FOR);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:bottom-28 sm:left-5 sm:right-auto" aria-live="polite" data-id="element-39" data-mp="117o4pyfyj74n">
      <AnimatePresence data-id="element-40" data-mp="1fv98zvokjce5">
        {open && !dismissed && <motion.div key={`${buyer.name}-${minutesAgo}`} initial={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_12px_32px_rgba(0,0,0,0.35)] sm:w-80" data-id="element-41" data-mp="1aw62s7wur04l">
            <img src="https://cdn.magicpatterns.com/uploads/wC5GWk7QhEuYwo2hpcbiFc/MOCKUP_PRINCIPAL_SIN_FONDO.png" alt="" className="h-12 w-12 shrink-0 object-contain" data-id="element-42" data-mp="28kg22f5979s0" />
            <div className="min-w-0 text-left" data-id="element-43" data-mp="23l3ko9x5iuwt">
              <p className="truncate text-sm font-bold text-ink-900" data-id="element-44" data-mp="2ap3037xgwma4">{buyer.name}</p>
              <p className="text-xs text-slate-600" data-id="element-45" data-mp="2fne8de846oq8">from {buyer.country} just purchased <span className="font-semibold text-ink-900" data-id="element-46" data-mp="2fpr02j3ocdgh">Occlusion Blueprint™</span></p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-medium text-emerald-600" data-id="element-47" data-mp="2kniov490vjgg">
                <CheckCircle2Icon className="h-3 w-3" aria-hidden="true" data-id="element-48" data-mp="2pjrdd8940p0a" /> Verified · {minutesAgo} min ago
              </p>
            </div>
            <button onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-slate-400 transition-colors duration-150 hover:text-slate-700" aria-label="Dismiss notification" data-id="element-49" data-mp="1wwn2wnr8zih4">
              <XIcon className="h-4 w-4" data-id="element-50" data-mp="26n7y017pq4va" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}